const questions = [
    { id: 1, question: "73 + 15 =", answer: 88 },
    { id: 2, question: "84 ÷ 4 =", answer: 21 },
    { id: 3, question: "49 - 22 =", answer: 27 },
    { id: 4, question: "25 × 3 =", answer: 75 },
    { id: 5, question: "753 + 74 =", answer: 827 },
  
    { id: 6, question: "132 ÷ 6 =", answer: 22 },
    { id: 7, question: "77 × 5 =", answer: 385 },
    { id: 8, question: "185 - 78 =", answer: 107 },
    { id: 9, question: "213 + 697 =", answer: 910 },
    { id: 10, question: "434 ÷ 7 =", answer: 62 },
  
    { id: 11, question: "406 - 297 =", answer: 109 },
    { id: 12, question: "251 × 7 =", answer: 1757 },
    { id: 13, question: "5794 + 587 =", answer: 6381 },
    { id: 14, question: "1884 ÷ 6 =", answer: 314 },
    { id: 15, question: "1148 - 439 =", answer: 709 },
  
    { id: 16, question: "9632 ÷ 8 =", answer: 1204 },
    { id: 17, question: "2043 × 4 =", answer: 8172 },
    { id: 18, question: "741 + 632 + 415 =", answer: 1788 },
    { id: 19, question: "23 × 17 =", answer: 391 },
    { id: 20, question: "20849 - 967 =", answer: 19882 },
  
    { id: 21, question: "6786 + 43255 =", answer: 50041 },
    { id: 22, question: "1188 ÷ 3 =", answer: 396 },
    { id: 23, question: "9427 - 1558 =", answer: 7869 },
    { id: 24, question: "231 × 21 =", answer: 4851 },
    { id: 25, question: "44186 + 27534 =", answer: 71720 },
  
    { id: 26, question: "6525 ÷ 15 =", answer: 435 },
    { id: 27, question: "758 × 34 =", answer: 25772 },
    { id: 28, question: "112104 - 78126 =", answer: 33978 },
    { id: 29, question: "6858 ÷ 27 =", answer: 254 },
    { id: 30, question: "7148 × 57 =", answer: 407436 },
  ];

  export default questions;